/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

function Banner({
    desktopImg,
    mobileImg,
    openSeaLink,
    title,
    buttonTitle,
}) {
    return (
        <div className="banner-hero-wrapper">
            <div className="banner-wrapper">
                <div className="banner-banner">
                    <div className="banner-desktop">
                        <h1 className="banner-hero-title">{title}</h1>
                        <img src={desktopImg} className="banner-hero-desktop" alt="logo" />
                        <a href={openSeaLink} target="_blank" rel="noreferrer"><span className="banner-hover-button">{ buttonTitle || 'View in Opensea'}</span></a>
                    </div>
                    <div className="banner-mobile">
                        <h1 className="banner-hero-title">{title}</h1>
                        <img src={mobileImg} alt="logo" />
                        <a href={openSeaLink}><span className="banner-hover-button">{ buttonTitle || 'View in Opensea'}</span></a>
                    </div>
                </div>

            </div>
        </div>
    )
}

Banner.defaultProps = {
    buttonTitle: null,
}

Banner.propTypes = {
    title: PropTypes.string.isRequired,
    desktopImg: PropTypes.string.isRequired,
    mobileImg: PropTypes.string.isRequired,
    openSeaLink: PropTypes.string.isRequired,
    buttonTitle: PropTypes.string,
}

export default Banner
